// extracted by mini-css-extract-plugin
export var animationContainer = "_kc-0";
export var footer = "_kc-1";
export var gray = "_kc-2";
export var lineItem = "_kc-3";
export var lineItemImage = "_kc-4";
export var lineItemInfo = "_kc-5";
export var lineItemText = "_kc-6";
export var lineItems = "_kc-7";
export var modalContent = "_kc-8";
export var options = "_kc-9";
export var orderName = "_kc-a";
export var refundAmount = "_kc-b";